import React, { Component } from 'react';
import Parse                from 'parse';
import classNames           from 'classnames/bind';
import Utils                from '../Utils/Utility';
import Spinner              from './generic/spinner';
import GrayNavBar           from './layout/gray-navbar';
import UserNavbar           from './layout/user-navbar';
import RegisterUser         from './register/RegisterUser.js';
import RegisterRestaurant   from './register/RegisterRestaurant.js';
import RegisterBusiness     from './register/RegisterBusiness';
import { Link }             from 'react-router'

let wllogo = require('../../img/wl-logo-blue.png');

export default class Register extends Component {

    constructor(props){
        super(props);
        this.state = {
            renderResturantRegPage:false
        };
        this.notifyEmailVerification=this.notifyEmailVerification.bind(this);
    }

    notifyEmailVerification(isEmailVerified){
        if(isEmailVerified){
            this.setState({renderResturantRegPage:true});
        }
    }

    render(){

        let emailVerified, businessAdded;

        if(this.props.location.state!=null){
            emailVerified = this.props.location.state.emailVerified;
            businessAdded = this.props.location.state.businessAdded;
        }

        let condition = this.state.renderResturantRegPage||emailVerified;

        return (
            <div>
                {
                    Parse.User.current() ? <UserNavbar /> : <GrayNavBar />
                }
                {
                    condition
                        ? (
                          <RegisterBusiness businessAdded={businessAdded} />
                        )
                        : (
                            <RegisterUser
                                callbackParent = {this.notifyEmailVerification}
                                emailVerified  = {emailVerified}
                            />
                        )
                }
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/register.js